import PropTypes from "prop-types";
import React from "react";
import { ButtonLarge } from "../ButtonLarge";
import "./style.css";

export const Shortcuts = ({ shortcuts, className }) => {
  return (
    <div className={`shortcuts ${shortcuts} ${className}`}>
      <div className="shortcut-box">
        <div className="frame">
          <div className="text-wrapper">Client</div>
        </div>
        <div className="button-large-wrapper">
          <ButtonLarge 
          className={`${shortcuts === "mobile" ? "class" : "class-2"}`} 
          text="Hire Talent" 
          linkTo="/talent"
          />
        </div>
      </div>
      <div className="shortcut-box">
        <div className="frame">
          <div className="text-wrapper">Talent</div>
        </div>
        <div className="button-large-wrapper">
          <ButtonLarge
            className="class-2"
            text="Explore Opportunities "
            linkTo="/jobs#jobPosts"
          />
        </div>
      </div>
    </div>
  );
};

Shortcuts.propTypes = {
  shortcuts: PropTypes.oneOf(["mobile", "default"]),
};
